import clsx from "clsx";
import React, { useEffect, useState } from "react";
import styles from "./DrawerBody.module.scss";
import { RemoveScroll } from "react-remove-scroll";

export type DrawerBodyProps = {
  dataContentName: string;
  show: boolean;
  className?: string;
  paddingTop?: boolean;
  children: (shouldRender: boolean) => React.ReactNode;
};

export const defaultDrawerBodyContainerStyle = styles.defaultContainer;

export const DrawerBody: React.FC<DrawerBodyProps> = ({
  paddingTop = true,
  show,
  className,
  dataContentName,
  children
}) => {
  const [shouldRender, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onTransitionEnd = () => {
    if (!show) setRender(false);
  };

  if (!shouldRender && !show) return null;

  return (
    <div
      data-content-name={dataContentName}
      onTransitionEnd={onTransitionEnd}
      className={clsx(
        styles.body,
        {
          [styles.paddingTop]: paddingTop,
          [styles.show]: shouldRender,
          [styles.hide]: !show
        },
        className
      )}
    >
      <RemoveScroll enabled={show} className={styles.contentWrapper}>
        {children(shouldRender)}
      </RemoveScroll>
    </div>
  );
};
